var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 105,
    viewBox: "0 0 343 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9411 0H0V104.129H47.9411C77.2657 104.129 101.035 80.3555 101.035 51.0343C101.035 21.7098 77.2623 0 47.9411 0ZM53.6109 56.7041H42.268V45.3646H53.6075V56.7041H53.6109Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.349 0C132.596 0 109.285 23.3104 109.285 52.0643C109.285 80.8181 132.596 104.129 161.349 104.129C190.103 104.129 213.414 80.8181 213.414 52.0643C213.414 23.3104 190.103 0 161.349 0ZM167.019 57.734H155.68V46.3945H167.019V57.734Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.736 0V104.129H272.95V68.0435H277.333L292.478 104.129H342.999L321.303 52.0643L342.999 0H292.083L276.817 35.5684H272.693V0H222.736Z",
    fill: "#D3D3D3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDok);
export default __webpack_public_path__ + "static/media/DOK.9d8ced768396361e9f8134a48fb36f98.svg";
export { ForwardRef as ReactComponent };